export enum AppUrls {
    // app pages
    HOME = '/',
    SIGN_UP = '/auth/signup',
    SIGN_IN = '/auth/signin',
    DASHBOARD = '/dashboard',
    SPREADSHEETS = '/spreadsheets',
    ME = '/me',
    VERIFY_EMAIL = '/auth/verify-email',
    EMAIL_VERIFIED = '/auth/email-verified',
    RESET_PASSWORD = '/auth/reset-password',
    FORGET_PASSWORD = '/auth/forget-password',
    CHANGELOG = '/changelog',

    // specs
    SPECS = 'https://docs.google.com/document/d/11X7BFZ-Ql1qsd6hJju-NjvJ-eMOTIUmB4oDA-rpLWW0/edit?tab=t.0',
    BRAND_GUIDELINES = 'https://drive.google.com/file/d/15nliI1ZYUF8LWwIZ1aAjEYNcsJkuyWNp/view',

    // echarts
    ECHARTS_EXAMPLES = 'https://echarts.apache.org/examples/en/index.html',
    ECHARTS = 'https://echarts.apache.org/en/cheat-sheet.html',

    // dayjs
    DAYJS_DOCS = 'https://day.js.org/docs/en/display/format',

    // numeral
    NUMERAL_DOCS = 'http://numeraljs.com/#format',

    // fberger
    DEV_WEBSITE = 'https://www.fberger.xyz/',
    DEV_TELEGRAM = 'https://t.me/fberger_xyz',
}

export enum AppThemes {
    LIGHT = 'light',
    DARK = 'dark',
}

export enum AppFontFamilies {
    ALLIANCE_2 = 'alliance-2',
    ALLIANCE_1 = 'alliance-1',
    ARIAL = 'arial',
    INTER = 'inter',
}
